<template lang="html">
    <div class="profile-files">
        <data-table
            :headers="datatable.headers"
            :endpoint="datatable.endpoint"
            :toolbar="datatable.toolbar"
            :actions="datatable.actions"
            :views="datatable.views"
            storeId="files"
            @rowClick="rowClick"
            @total_updated="update_count"
            ref="list"
            selectable
            :isFixed="false"
        >

            <template slot="items" slot-scope="props">
                <td>
                    {{ props.item.label }}
                </td>

                <td class="text-xs-right">
                    {{ moment(props.item.created_at).format('L') }}
                </td>
                <td class="text-xs-right" v-if="$_.find(users,u => u.id == props.item.created_by)">
                    {{ $_.find(users,u => u.id == props.item.created_by).first_name }} {{ $_.find(users,u => u.id == props.item.created_by).last_name }}
                </td>
                <td class="text-xs-right" v-else>
                    -
                </td>
                <td class="text-xs-right">
                    {{ props.item.type }}
                </td>
                <td class="text-xs-center">
                    <v-btn small icon :disabled="$store.state.auth.user.level < 60" @click.stop="$refs.updatefile.open(props.item)"><v-icon>mode_edit</v-icon></v-btn>
                </td>
            </template>
        </data-table>
        <update-files ref="updatefile" entity="products"></update-files>
    </div>
</template>

<script>
    import DataTable       from '../../../components/DataTable.vue'
    import DeleteFiles     from '../../../components/files/DeleteFiles.vue'
    import CreateFiles     from '../../../components/files/CreateFiles.vue'
    import UpdateFiles     from '../../../components/files/UpdateFiles.vue'
    import moment from 'moment'
    moment.locale('fr')

    export default {

        components:{DataTable,UpdateFiles,CreateFiles,DeleteFiles},

        data() {
            return {
                moment,
                datatable: {
                    toolbar: [
                        { icon: 'delete',                   callback: () => { this.$eventHub.$emit('open-modal', DeleteFiles,{entity: 'products'}) }, level: 60 },
                    ],
                    actions: [
                        { text: 'Ajouter un fichier',    icon:"add_circle",       callback: () => { this.$eventHub.$emit('open-modal', CreateFiles,{entity: 'products'}) }, level: 60 },
                    ],
                    headers: [
                        { text: 'Nom', sortable: true, value: 'name', align: 'left' },
                        { text: 'Date de l\'ajout', sortable: true, value: 'created_at', align: 'right' },
                        { text: 'Auteur', sortable: false, value: 'created_by', align: 'right' },
                        { text: 'Type', sortable: true, value: 'type', align: 'right' },
                        { text: 'Action', sortable: false, value: 'action' },
                    ],
                    endpoint: {
                        base: `/api/files`,
                        filters: `products.id|=|${this.$route.params.id}`,
                        embed: ``
                    },
                },
                users: [],
                items:[]
            }
        },

        methods: {
            rowClick(item) {
                this.$eventHub.$emit('view-file',item,this.items)
            },
            update_count(count){
                this.$store.dispatch('updateSingleData', { key:'files_count', value:count})
                this.$store.dispatch('updateSingleData', { key:'files', value: this.$refs.list.items})
            }
        },
        created() {
            this.$eventHub.$on('reload-list',() => {
                if(this.$refs.list) {
                    this.$refs.list.reload()
                }
            })
            this.$eventHub.$on('getItems',(items) => {
                this.items = items
            })
        },
        mounted() {
            this.axios.get(`/api/users`)
            .then(response => {
                this.users = response.data
            })
        }
    }
</script>

<style lang="stylus" scoped>
    @require '../../../assets/css/variables'
    .single-mission {
        margin-top: 3rem

    }
</style>



// WEBPACK FOOTER //
// src/views/products/single/Files.vue